import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const STATUS_COLOR = {
  PROCESSED: "text-emerald-400",
  DUPLICATE: "text-yellow-400",
  FAILED: "text-rose-400",
  RECEIVED: "text-cyan-400",
};

export default function Integrationen() {
  const [status, setStatus] = useState("all");
  const [provider, setProvider] = useState("all");

  const events = useQuery({
    queryKey: ["sync-events", status, provider],
    queryFn: async () => (await api.get("/vending/events", {
      params: {
        status: status === "all" ? undefined : status,
        provider: provider === "all" ? undefined : provider,
      },
    })).data,
    refetchInterval: 5000,
  });
  const providers = useQuery({
    queryKey: ["vending-providers"],
    queryFn: async () => (await api.get("/vending/providers")).data.providers,
  });

  return (
    <div data-testid="integrations-page">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-cyan-400">Integrationen</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight">Sync-Ereignisse</h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger data-testid="sync-filter-status" className="h-11 bg-zinc-900 border-zinc-800 rounded-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-zinc-950 border-zinc-800">
            <SelectItem value="all">Alle Status</SelectItem>
            <SelectItem value="PROCESSED">Processed</SelectItem>
            <SelectItem value="DUPLICATE">Duplicate</SelectItem>
            <SelectItem value="FAILED">Failed</SelectItem>
            <SelectItem value="RECEIVED">Received</SelectItem>
          </SelectContent>
        </Select>
        <Select value={provider} onValueChange={setProvider}>
          <SelectTrigger data-testid="sync-filter-provider" className="h-11 bg-zinc-900 border-zinc-800 rounded-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-zinc-950 border-zinc-800">
            <SelectItem value="all">Alle Provider</SelectItem>
            {(providers.data || []).map((p) => (
              <SelectItem key={p} value={p}>{p}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="border border-zinc-800 bg-zinc-900 rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-wider text-zinc-500 border-b border-zinc-800">
            <tr>
              <th className="text-left px-4 py-3 font-mono">Empfangen</th>
              <th className="text-left px-4 py-3">Provider</th>
              <th className="text-left px-4 py-3 font-mono">External ID</th>
              <th className="text-left px-4 py-3 font-mono">Machine</th>
              <th className="text-right px-4 py-3 font-mono">Menge</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Fehler</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800" data-testid="sync-events-tbody">
            {(events.data || []).map((e) => (
              <tr key={e.id} className="hover:bg-zinc-800/60">
                <td className="px-4 py-2 font-mono text-xs text-zinc-400">
                  {new Date(e.received_at).toLocaleString("de-DE")}
                </td>
                <td className="px-4 py-2 uppercase text-cyan-400">{e.provider}</td>
                <td className="px-4 py-2 font-mono">{e.external_id}</td>
                <td className="px-4 py-2 font-mono">{e.external_machine_id || "—"}</td>
                <td className="px-4 py-2 text-right font-mono">{e.quantity}</td>
                <td className={`px-4 py-2 text-xs uppercase ${STATUS_COLOR[e.status] || ""}`}>
                  {e.status}
                </td>
                <td className="px-4 py-2 text-xs text-zinc-400">
                  {e.error_code ? <><span className="text-rose-400">{e.error_code}</span> — {e.error_message}</> : "—"}
                </td>
              </tr>
            ))}
            {!events.data?.length && (
              <tr><td colSpan={7} className="px-4 py-8 text-center text-zinc-500">Noch keine Events erfasst.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
